import React from "react";
import { MdEdit, MdDelete, MdRemoveRedEye } from "react-icons/md";

const InscriptionTable = ({ inscriptions, loading, onEdit, onDelete, onView }) => {
  // Formatage de la date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="overflow-hidden rounded-lg shadow-sm border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-700"
            >
              Étudiant
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden md:table-cell"
            >
              Niveau
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden lg:table-cell"
            >
              Parcours/Mention
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden sm:table-cell"
            >
              Année univ.
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700"
            >
              Date
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {loading && inscriptions.length === 0 ? (
            <tr>
              <td colSpan="6" className="px-3 py-6 text-center text-sm text-gray-500">
                <div className="flex justify-center">
                  <svg className="animate-spin h-5 w-5 text-purple-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              </td>
            </tr>
          ) : inscriptions.length === 0 ? (
            <tr>
              <td colSpan="6" className="px-3 py-6 text-center text-sm text-gray-500">
                <p>Aucune inscription trouvée</p>
                <p className="text-xs text-gray-400 mt-1">
                  Créez une nouvelle inscription en utilisant les boutons ci-dessus
                </p>
              </td>
            </tr>
          ) : (
            inscriptions.map((inscription) => (
              <tr key={inscription.id_inscrit} className="hover:bg-gray-50 transition-colors">
                <td className="py-4 pl-4 pr-3 text-sm">
                  <div className="font-medium text-gray-900">
                    {inscription.nom_prenom_membre}
                  </div>
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden md:table-cell">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 border border-purple-200">
                    {inscription.niveau}
                  </span>
                </td>
                <td className="px-3 py-4 text-sm text-gray-600 hidden lg:table-cell">
                  <div>
                    <div className="font-medium">{inscription.name_parcours}</div>
                    <div className="text-xs text-gray-500 mt-1">{inscription.name_mention}</div>
                  </div>
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden sm:table-cell">
                  {inscription.dateuniv}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                  {formatDate(inscription.date_inscrit)}
                </td>
                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                  <div className="flex justify-end gap-2">
                    <button
                      onClick={() => onView(inscription)}
                      className="p-1.5 text-purple-600 hover:text-purple-900 rounded-md hover:bg-gray-100 transition-colors"
                      title="Voir les détails"
                    >
                      <MdRemoveRedEye className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onEdit(inscription)}
                      className="p-1.5 text-gray-600 hover:text-gray-900 rounded-md hover:bg-gray-100 transition-colors"
                      title="Modifier"
                    >
                      <MdEdit className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onDelete(inscription)}
                      className="p-1.5 text-red-500 hover:text-red-700 rounded-md hover:bg-gray-100 transition-colors"
                      title="Supprimer"
                    >
                      <MdDelete className="h-5 w-5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InscriptionTable;